import { render } from "./add-page.vue?vue&type=template&id=5b64a654"
import script from "./add-page.vue?vue&type=script&lang=js"
export * from "./add-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__